import React, { useEffect, useState } from "react";
import { CompanyCard, CustomButton, Header, ListBox, Loading } from "../components";
import axios from "axios";

const Companies = () => {
  const [page, setPage] = useState(1);
  const [numPage, setNumPage] = useState(1);
  const [recordsCount, setRecordsCount] = useState(0);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [cmpLocation, setCmpLocation] = useState("");
  const [sort, setSort] = useState("Newest"); // Default sorting criteria
  const [isFetching, setIsFetching] = useState(false);



  useEffect(() => {
    const fetchData = async () => {
      setIsFetching(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/company/company`, {
          params: {
            search: searchQuery,
            sort,
            location: cmpLocation, // Include cmpLocation in the request params
            page,
          },
        });
        setData(response.data.data);
        setRecordsCount(response.data.total);
        setNumPage(response.data.numOfPage);
        setIsFetching(false);
      } catch (error) {
        console.error('Error fetching companies:', error);
        setIsFetching(false);
      }
    };
    fetchData()
  }, [sort,page, searchQuery, cmpLocation]); // Added cmpLocation to the dependency array

  

  const handleShowMore = () => {
    setPage(page + 1);
  };

  const handleSearchSubmit = async () => {
    setPage(1); // Reset page number when performing a new search
  };

  const handleSortChange = (selectedSort) => {
    setSort(selectedSort);
  };

  return (
    <div className='w-full'>
      <Header
        title='Find Your Dream Company'
        handleClick={handleSearchSubmit}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        location={cmpLocation}
        setLocation={setCmpLocation} // Fixed setLocation to setCmpLocation
      />

      <div className='container mx-auto flex flex-col gap-5 2xl:gap-10 px-5 md:px-0 py-6 bg-[#f7fdfd]'>
        <div className='flex items-center justify-between mb-4'>
          <p className='text-sm md:text-base'>
            Showing: <span className='font-semibold'>{recordsCount}</span> Companies Available
          </p>
          <div className='flex flex-col md:flex-row gap-0 md:gap-2 md:items-center'>
            <p className='text-sm md:text-base'>Sort By:</p>

            <ListBox sort={sort} setSort={handleSortChange} />
          </div>
        </div>

        <div className='w-full flex flex-col gap-6'>
          {data.length > 0 ? (
            data.map((cmp) => (
              <CompanyCard cmp={cmp} key={cmp._id} />
            ))
          ) : (
            <p>No companies found</p>
          )}

          {isFetching && (
            <div className='mt-10'>
              <Loading />
            </div>
          )}

          {data.length > 0 && (
            <p className='text-sm text-right'>
              {data.length} records out of {recordsCount}
            </p>
          )}
        </div>

        {numPage > page && !isFetching && (
          <div className='w-full flex items-center justify-center pt-16'>
            <CustomButton
              onClick={handleShowMore}
              title='Load More'
              containerStyles={`text-blue-600 py-1.5 px-5 focus:outline-none hover:bg-blue-700 hover:text-white rounded-full text-base border border-blue-600`}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Companies;
